const darkBlue = '#202C3C';

export default darkBlue;
